import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import mobileAppBridge from 'app/libs/MobileAppBridge';
import { testFullUrl } from 'app/libs/regEx';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import { getUserInfo, sessionCheck } from 'app/store/modules/auth';
import { useDispatch } from 'react-redux';
import qs from 'query-string';
import { testEncodedUrl } from '@encarpkg/shared';

function useGoLogin() {
	const ua = useSsrUserAgent();
	const history = useHistory();
	const dispatch = useDispatch();

	return useCallback(
		(options) => {
			const {
				replace = false,
				returnUrl,
				useAlertCheckAuth,
				useCloseBtn,
				destroyWebViewAfterLogin,
				popupMode = false,
				onLoginSuccessInPopup, // 팝업모드에서 로그인 성공시 콜백 함수
				directUrl,
				service,
				skipAble = false,
				skipPath,
				returnNativePage, // 정의한 값에 따라 네이티브 뷰로 열림
			} = options || {};

			const search = {
				...(returnUrl && { returnUrl: decodeURIComponent(returnUrl) }),
				...(useCloseBtn && { useCloseBtn: 'true' }),
				...(popupMode && { popupMode: 'true' }),
				...(directUrl && { directUrl: decodeURIComponent(directUrl) }),
				...(service && { service }),
				...(skipAble && { skipAble: 'true' }),
				...(skipPath && { skipPath: testEncodedUrl(skipPath) ? decodeURIComponent(skipPath) : skipPath }),
			};

			const nextUrl = {
				pathname: '/login',
				search: `?${qs.stringify(search)}`,
			};

			if (useAlertCheckAuth) alert('로그인이 필요한 서비스입니다.');

			if (ua().isApp) {
				const fullReturnUrl = testFullUrl(returnUrl)
					? returnUrl
					: `${window.location.protocol}//${window.location.host}${decodeURIComponent(returnUrl)}`;
				const fullDirectUrl = testFullUrl(directUrl)
					? directUrl
					: `${window.location.protocol}//${window.location.host}${decodeURIComponent(directUrl)}`;
				const oldIOS = ua().isIOS && ua().lessThanAppVersion('4.1.0');
				const oldAndroid = ua().isAndroid && ua().lessThanAppVersion('5.1.2');
				if (oldAndroid || oldIOS) {
					mobileAppBridge().login('', true);
				} else {
					mobileAppBridge().loginWithParam(
						{
							backUrl: returnUrl ? fullReturnUrl : '',
							closeUrl: destroyWebViewAfterLogin ? 'destroyWebView' : directUrl && fullDirectUrl,
							service,
							...(skipAble && { skipAble: 'true' }),
							...(skipPath && { skipPath: testEncodedUrl(skipPath) ? decodeURIComponent(skipPath) : skipPath }),
							...(returnNativePage && { returnNativePage }),
						},
						true,
						skipAble,
					);
				}
				setTimeout(() => history.goBack(), 300);
				return;
			}

			if (replace) {
				history.replace(nextUrl);
				return;
			}

			if (popupMode) {
				const loginPopup = window.open(`${nextUrl.pathname}${nextUrl.search}`, 'loginPopup', 'width=450,height=800,scrollbars=yes');
				window.onLoginSuccess = async () => {
					await Promise.all([dispatch(getUserInfo()), dispatch(sessionCheck())]);
					window.onLoginSuccess = null;
					if (onLoginSuccessInPopup) {
						onLoginSuccessInPopup();
						loginPopup.close();
					}
				};
				return;
			}

			history.push(nextUrl);
		},
		[history, ua, dispatch],
	);
}

export default useGoLogin;
